module.exports = __webpack_public_path__ + "static/media/Ingress.bf921995.svg";